import { events } from "./events/index";

const { components } = require("./components/index");

const MRC2AttachmentsSection = {
  components,
  events
}

export { MRC2AttachmentsSection }